import { Check, X } from "lucide-react";
import Reveal, { SectionHead } from "./Reveal";
import { scrollToId } from "@/lib/api";

const NOT_NEEDED = [
  "You do not need to become a media company.",
  "You do not need to hire a full-time communications department.",
  "You do not need to chase every trend.",
];

const NEEDED = [
  "A clear Kingdom message.",
  "A visible digital presence.",
  "A consistent system that turns what God is already doing into content that informs, inspires, invites, and connects.",
];

const STEPS = [
  ["We Diagnose Your Digital Presence", "We identify what is missing, unclear, outdated, disconnected, or invisible — and score your Digital Visibility from 1–10."],
  ["We Build Your Digital Doorway", "We set up or transform your social profiles, church links, visitor journey, brand presence, and content foundation in 30 days."],
  ["We Activate Your Digital Pulpit", "We turn sermons, worship, prayer, events, and testimonies into consistent online content that invites people into real church community."],
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-8 bg-navy-surface/40">
      <div className="max-w-7xl mx-auto">
        <SectionHead eyebrow="The Solution · The 90-Day Church Visibility Plan"
          title="We Turn Your Existing Ministry Into Daily Digital Impact." />

        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <Reveal>
            <div className="rounded-lg border border-white/10 bg-navy-surface p-7 h-full">
              <p className="text-[10px] tracking-[0.3em] uppercase text-slate-500 mb-5">What you don’t need</p>
              <ul className="space-y-4">
                {NOT_NEEDED.map((t) => (
                  <li key={t} className="flex items-start gap-3 text-sm text-slate-400">
                    <X size={16} className="text-crimson mt-0.5 shrink-0" />{t}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="rounded-lg border border-gold/40 bg-gold/5 p-7 h-full shadow-[0_0_25px_rgba(212,175,55,0.08)]">
              <p className="text-[10px] tracking-[0.3em] uppercase text-gold mb-5">What you do need</p>
              <ul className="space-y-4">
                {NEEDED.map((t) => (
                  <li key={t} className="flex items-start gap-3 text-sm text-slate-200">
                    <Check size={16} className="text-gold mt-0.5 shrink-0" />{t}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6" data-testid="process-steps">
          {STEPS.map(([title, body], i) => (
            <Reveal key={title} delay={i * 0.08}>
              <div className="group h-full border-t-2 border-gold/30 pt-8 transition-colors hover:border-gold">
                <span className="font-display text-6xl text-gold/25 group-hover:text-gold/70 transition-colors duration-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-4 font-display text-lg sm:text-xl uppercase tracking-tight text-white">{title}</h3>
                <p className="mt-3 text-sm text-slate-300 leading-relaxed">{body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <button data-testid="process-launch-cta-button" onClick={() => scrollToId("packages")}
            className="mt-14 rounded-full border border-gold/50 px-8 py-4 text-xs font-bold tracking-[0.18em] uppercase text-gold transition-all hover:bg-gold hover:text-navy hover:scale-[1.03]">
            Start With a 30-Day Kingdom Visibility Launch
          </button>
        </Reveal>
      </div>
    </section>
  );
}
